import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { applyFavicon } from '../../utils/seo';
import { Footer } from './Footer';
import { Header } from './Header';
import { ScrollManager } from './ScrollManager';
export function Layout() {
  const location = useLocation();
  useEffect(() => {
    applyFavicon();
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-porcelain" data-id="element-362" data-mp="3546ac0j8q6z7">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-full focus:bg-copper focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-white" data-id="element-363" data-mp="3a2hjsa5mifgw">
        Skip to content
      </a>
      <ScrollManager data-id="element-364" data-mp="3j0tlb7812xo4" />
      <Header data-id="element-365" data-mp="1kntbak05lho5" />
      <motion.main id="main-content" key={location.pathname} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="flex-1" data-id="element-366" data-mp="1kobek0l8gw5k">
        <Outlet data-id="element-367" data-mp="3n2d5d5ljlyzb" />
      </motion.main>
      <Footer data-id="element-368" data-mp="3ia3hdv3zn8zo" />
    </div>;
}